// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GAgkewqKOTczq16C {
	font: var(--lok-typography-body-small-strong);
	font-family: var(--lok-font-family-inter);
}

.pwC7JvBxzFQwjBLI {
	display: flex;
	align-items: center;
	gap: var(--lok-spacing-1);

	color: var(--lok-color-text-warning);
	font: var(--lok-typography-body-tiny-default);
	font-family: var(--lok-font-family-inter);

	> span {
		flex: 1;
	}
}
`, "",{"version":3,"sources":["webpack://./packages/rag/src/components/UserCreatedProfileModal/components/ProfileBasicsStep/ProfileBasics.module.css"],"names":[],"mappings":"AAAA;CACC,6CAA6C;CAC7C,yCAAyC;AAC1C;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,yBAAyB;;CAEzB,oCAAoC;CACpC,6CAA6C;CAC7C,yCAAyC;;CAEzC;EACC,OAAO;CACR;AACD","sourcesContent":[".heading {\n\tfont: var(--lok-typography-body-small-strong);\n\tfont-family: var(--lok-font-family-inter);\n}\n\n.warning {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: var(--lok-spacing-1);\n\n\tcolor: var(--lok-color-text-warning);\n\tfont: var(--lok-typography-body-tiny-default);\n\tfont-family: var(--lok-font-family-inter);\n\n\t> span {\n\t\tflex: 1;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"heading": `GAgkewqKOTczq16C`,
	"warning": `pwC7JvBxzFQwjBLI`
};
export default ___CSS_LOADER_EXPORT___;
